var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("sfe.taskList.BoxWrap.manage") } },
        [
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{ pageName, list: ['LIST'] }",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{ pageName, list: ['LIST'] }",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{ pageName, list: ['LIST'] }",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { size: "small", inline: "", "label-position": "top" },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "row-bg", attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sfe.taskList.input.dateRange"),
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  clearable: "",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  placeholder: _vm.$t(
                                    "sfe.taskList.input.startTimeHolder"
                                  ),
                                },
                                model: {
                                  value: _vm.searchVal.startTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "startTime", $$v)
                                  },
                                  expression: "searchVal.startTime",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "picker-line" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("el-date-picker", {
                                attrs: {
                                  clearable: "",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  placeholder: _vm.$t(
                                    "sfe.taskList.input.endTimeHolder"
                                  ),
                                },
                                model: {
                                  value: _vm.searchVal.endTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "endTime", $$v)
                                  },
                                  expression: "searchVal.endTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sfe.taskList.input.taskType"),
                              },
                            },
                            [
                              _c("FormSelect", {
                                attrs: {
                                  val: _vm.searchVal.taskType,
                                  options: _vm.optConfig.planTypeOptions,
                                },
                                on: {
                                  "update:val": function ($event) {
                                    return _vm.$set(
                                      _vm.searchVal,
                                      "taskType",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sfe.taskList.input.readFlag"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { clearable: "" },
                                  model: {
                                    value: _vm.searchVal.readFlag,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchVal, "readFlag", $$v)
                                    },
                                    expression: "searchVal.readFlag",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "已读", value: "Y" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "未读", value: "N" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _vm.userRole === "ASM"
                        ? _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("sfe.taskList.input.srEmpNo"),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t("common.pleaseInput"),
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchVal.srEmpNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.searchVal, "srEmpNo", $$v)
                                      },
                                      expression: "searchVal.srEmpNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("sfe.taskList.BoxWrap.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{ pageName, list: ['EXPORT'] }",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.downloadExcel },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.export")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "srEmpNo",
                  label: _vm.$t("sfe.taskList.table.srEmpNo"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "srEmpName",
                  label: _vm.$t("sfe.taskList.table.srEmpName"),
                  "min-width": "100",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "nowTime",
                  label: _vm.$t("sfe.taskList.table.nowTime"),
                  formatter: _vm.formatterValues,
                  "min-width": "140",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "distributionName",
                  label: _vm.$t("sfe.taskList.table.distributionName"),
                  "min-width": "140",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "readFlag",
                  label: _vm.$t("sfe.taskList.table.readFlag"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                  formatter: _vm.formatterValues,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "taskFromType",
                  label: _vm.$t("sfe.taskList.table.taskFromType"),
                  "min-width": "140",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "taskType",
                  label: _vm.$t("sfe.taskList.table.taskType"),
                  formatter: _vm.formatterValues,
                  "min-width": "140",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlRtmCategory",
                  label: _vm.$t("sfe.taskList.table.rtlRtmCategory"),
                  "min-width": "140",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerType",
                  label: _vm.$t("sfe.taskList.table.retailerType"),
                  "min-width": "140",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlFullName",
                  label: _vm.$t("sfe.taskList.table.rtlFullName"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlAddress",
                  label: _vm.$t("sfe.taskList.table.rtlAddress"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scoped) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              "" +
                                (scoped.row.rtlRegion || "") +
                                (scoped.row.rtlCity || "") +
                                (scoped.row.rtlDistrict || "")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "signBoardBidFlag",
                  label: _vm.$t("sfe.taskList.table.signBoardBidFlag"),
                  formatter: _vm.formatterValues,
                  "min-width": "100",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "visitPurpose",
                  label: _vm.$t("sfe.taskList.table.visitPurpose"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dueTime",
                  label: _vm.$t("sfe.taskList.table.dueTime"),
                  formatter: _vm.formatterValues,
                  "min-width": "140",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "comment",
                  label: _vm.$t("sfe.taskList.table.remark"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("sfe.taskList.table.action"),
                  fixed: "right",
                  width: "200",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", {
                          directives: [
                            {
                              name: "FPermission",
                              rawName: "v-FPermission",
                              value: { pageName: _vm.pageName, list: ["LIST"] },
                              expression: "{ pageName, list: ['LIST'] }",
                            },
                          ],
                          staticClass: "t-square-btn t-green-btn",
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-tickets",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.detail(scope.row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.isShowModel, width: "60%" },
          on: {
            "update:visible": function ($event) {
              _vm.isShowModel = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { model: _vm.form, size: "small", inline: "" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sfe.taskList.form.srEmpNo"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { disabled: "", val: _vm.form.srEmpNo },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "srEmpNo", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sfe.taskList.form.srEmpName"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { disabled: "", val: _vm.form.srEmpName },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "srEmpName", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sfe.taskList.form.nowTime"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormDatePicker", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.nowTime,
                      valueformat: "yyyyMMdd",
                      type: "date",
                      placeholder: _vm.$t("sfe.taskList.form.nowTime"),
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "nowTime", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sfe.taskList.form.distributionName"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { disabled: "", val: _vm.form.distributionName },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "distributionName", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "readFlag",
                    label: _vm.$t("sfe.taskList.form.readFlag"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.readFlag,
                      options: [
                        { name: "已读", code: "Y" },
                        { name: "未读", code: "N" },
                      ],
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "readFlag", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "taskFromType",
                    label: _vm.$t("sfe.taskList.form.taskFromType"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.taskFromType,
                      options: _vm.optConfig.taskFromOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "taskFromType", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "taskType",
                    label: _vm.$t("sfe.taskList.form.taskType"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.taskType,
                      options: _vm.optConfig.planTypeOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "taskType", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sfe.taskList.form.rtlRtmCategory"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.rtlRtmCategory,
                      options: _vm.optConfig.rtmOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "rtlRtmCategory", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sfe.taskList.form.retailerType"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.retailerType,
                      options: _vm.optConfig.storeCategoryOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "retailerType", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "storeAddress",
                    label: _vm.$t("sfe.taskList.form.rtlAddress"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { disabled: "", val: _vm.form.storeAddress },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "storeAddress", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "signBoardBidFlag",
                    label: _vm.$t("sfe.taskList.form.signBoardBidFlag"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.signBoardBidFlag,
                      options: _vm.optConfig.yesnoOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "signBoardBidFlag", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "retailorStoreInfoPk",
                    label: _vm.$t("sfe.taskList.form.rtlFullName"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { disabled: "", val: _vm.form.rtlFullName },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "rtlFullName", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "visitPurpose",
                    label: _vm.$t("sfe.taskList.form.visitPurpose"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.visitPurpose,
                      options: _vm.optConfig.visitPurposeOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "visitPurpose", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "dueTime",
                    label: _vm.$t("sfe.taskList.form.dueTime"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormDatePicker", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.dueTime,
                      valueformat: "yyyy-MM-dd",
                      type: "date",
                      placeholder: _vm.$t("sfe.taskList.form.dueTime"),
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "dueTime", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "flexRow",
                  attrs: {
                    prop: "comment",
                    label: _vm.$t("sfe.taskList.form.remark"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormTextArea", {
                    attrs: { disabled: "", val: _vm.form.comment },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "comment", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }